import * as React from 'react';
import { Tooltip } from 'reactstrap';
import { mybswhTooltipMsg, translateText } from '../../helpers/data';

export default class FilterItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { filterMybswhTooltipOpen: false };
    }

    onChange(checked, value) {
        const { onChange } = this.props;
        if (onChange) {
            onChange(checked, value);
        }
    }

    updateList(list, value, checked) {
        const index = list.indexOf(value);
        if (checked && index === -1) {
            list.push(value);
        }
        else if (!checked && index > -1) {
            list.splice(index, 1);
        }

        const { onChange } = this.props;
        if (onChange) {
            onChange(list);
        }
    }

    toggleFilterMyBSWHTooltip = () => {
        this.setState({ filterMybswhTooltipOpen: !this.state.filterMybswhTooltipOpen });
    }

    render() {
        const { item, checked, valueField, displayField, name, t, translate } = this.props;

        if (!item) return null;

        const type = typeof item.type !== 'undefined' ? item.type : 'checkbox';

        switch (type) {
            case 'portal':
                return (
                    <li>
                        <div className="mybswh-perk-filter-container">
                            <label className="checkbox-container mybswh-perk-filter">
                                <input type="checkbox" name="mybswh" checked={typeof checked !== 'undefined' ? checked : item.value}
                                    onChange={e => this.onChange(e.target.checked)}
                                />
                                <span className="checkmark" />
                                <span className="filter-name"><img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> portal</span>
                            </label>
                            <div className="mybswh-tooltip">
                                <span className="mybswh-perk-container" onClick={this.toggleFilterMyBSWHTooltip}>
                                    <span className="mybswh-perk-label"><img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> portal </span><span className="icon-question" id="filterMybswhTooltip" />
                                    <Tooltip placement="top-end" className="filter-list-mybswh-perk" isOpen={this.state.filterMybswhTooltipOpen}
                                        autohide={false} target="filterMybswhTooltip" toggle={this.toggleFilterMyBSWHTooltip}
                                    >{mybswhTooltipMsg}</Tooltip>
                                </span>
                            </div>
                        </div>
                    </li>
                );
            case 'radios':
                return !item.display ? null : item.display.map((option, index) =>
                    <li key={index}>
                        <label className="radio-btn-container">
                            <input type="radio" name={name} checked={option[valueField] === item.value}
                                onChange={e => this.onChange(e.target.checked, option[valueField])}
                            />
                            <span className="radio-btn" />
                            <span className="filter-name">{translateText(t && translate, option[displayField], t)}</span>
                        </label>
                    </li>
                );
            case 'checkboxes':
                return !item.display ? null : item.display.map((option, index) =>
                    <li key={index}>
                        <label className="checkbox-container">
                            <input type="checkbox" checked={item.value.indexOf(option[displayField]) > -1}
                                onChange={e => this.updateList(item.value, option[displayField], e.target.checked)}
                            />
                            <span className="checkmark" />
                            <span className="filter-name">{translateText(t && translate, option[displayField], t)}</span>
                        </label>
                    </li>
                );
            case 'radio':
                return (
                    <li>
                        <label className="radio-btn-container">
                            <input type="radio" name={name} checked={typeof checked !== 'undefined' ? checked : item.value}
                                onChange={e => this.onChange(e.target.checked, item.value)}
                            />
                            <span className="radio-btn" />
                            <span className="filter-name">{translateText(t && translate, item.display, t)}</span>
                        </label>
                    </li>
                );
            default:
                return (
                    <li>
                        <label className="checkbox-container">
                            <input type="checkbox" checked={typeof checked !== 'undefined' ? checked : item.value}
                                onChange={e => this.onChange(e.target.checked, item.value)}
                            />
                            <span className="checkmark" />
                            <span className="filter-name">{translateText(t && translate, item.display, t)}</span>
                        </label>
                    </li>
                );
        }
    }
}